import React from 'react';
import { Bell, Check, Loader2, Plus, Save, Search, Trash2, Upload, Users, X, Edit2 } from 'lucide-react';

const StudentsTab = ({ ctx }) => {
  const {  summary, members, memberTotal, API_URL, getToken, fetchStudents, showAddForm, showBulkUpload, saving, uploading, uploadResult, addForm, editForm, editingStudent, setShowAddForm, setShowBulkUpload, setAddForm, setEditForm, setEditingStudent, fileRef, addStudent, handleBulkUpload, deleteStudent, startEdit, saveEdit, searchQuery, setSearchQuery, teamFilter, setTeamFilter, leadFilter, setLeadFilter , US_GRADES, bulkAction, selectedStudents, setBulkAction, setSelectedStudents } = ctx;

  return (
<div data-testid="students-tab">
  <div className="flex items-center justify-between mb-4">
    <div>
      <h1 className="text-xl font-bold" style={{ color: '#1A1209' }}>Team Roster</h1>
      <p className="text-xs" style={{ color: '#999' }}>{memberTotal} student{memberTotal !== 1 ? 's' : ''} enrolled</p>
    </div>
    <div className="flex gap-2">
      <button onClick={() => { setShowBulkUpload(!showBulkUpload); setShowAddForm(false); }}
        className="px-3 py-2 rounded-lg text-xs font-medium flex items-center gap-1.5"
        style={{ backgroundColor: '#F0F0F0', color: '#555' }} data-testid="bulk-upload-btn">
        <Upload size={13} /> Bulk CSV Upload
      </button>
      <button onClick={() => { setShowAddForm(!showAddForm); setShowBulkUpload(false); }}
        className="px-3 py-2 rounded-lg text-xs font-medium text-white flex items-center gap-1.5"
        style={{ backgroundColor: '#F5831F' }} data-testid="add-student-btn">
        <Plus size={13} /> Add Member
      </button>
    </div>
  </div>

  {/* Bulk upload panel */}
  {showBulkUpload && (
    <div className="bg-white p-4 rounded-xl mb-4" style={{ border: '1px solid #E8E8E8' }} data-testid="bulk-upload-panel">
      <h3 className="text-sm font-bold mb-2" style={{ color: '#1A1209' }}>Upload Students via CSV</h3>
      <p className="text-xs mb-3" style={{ color: '#888' }}>
        CSV columns: <code className="px-1 py-0.5 rounded text-[10px]" style={{ backgroundColor: '#F0F0F0' }}>first_name, last_name, grade, section, teacher_name, gender, parent_email, parent_name</code>
      </p>
      <input type="file" ref={fileRef} accept=".csv" onChange={handleBulkUpload} className="hidden" />
      <button onClick={() => fileRef.current?.click()} disabled={uploading}
        className="px-4 py-2 rounded-lg text-sm font-medium text-white disabled:opacity-50 flex items-center gap-1.5"
        style={{ backgroundColor: '#2563EB' }} data-testid="csv-upload-trigger">
        {uploading ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />}
        {uploading ? 'Uploading...' : 'Select CSV File'}
      </button>
      {uploadResult && (
        <div className="mt-3 text-xs p-3 rounded-lg" style={{ backgroundColor: uploadResult.added > 0 ? '#F0FDF4' : '#FEF2F2' }}>
          <p><strong>{uploadResult.added}</strong> students added{uploadResult.skipped > 0 && <>, <strong>{uploadResult.skipped}</strong> skipped</>}</p>
          {uploadResult.errors?.length > 0 && uploadResult.errors.map((e, i) => <p key={i} style={{ color: '#DC2626' }}>{e}</p>)}
        </div>
      )}
    </div>
  )}

  {/* Add student form */}
  {showAddForm && (
    <div className="bg-white p-4 rounded-xl mb-4" style={{ border: '2px solid #F5831F33' }} data-testid="add-student-form">
      <h3 className="text-sm font-bold mb-3" style={{ color: '#1A1209' }}>Add Member</h3>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-2">
        <input value={addForm.first_name} onChange={e => setAddForm(p => ({...p, first_name: e.target.value}))}
          placeholder="First name *" className="px-3 py-2 border rounded-lg text-sm" style={{ borderColor: '#E0E0E0' }} data-testid="add-first-name" />
        <input value={addForm.last_name} onChange={e => setAddForm(p => ({...p, last_name: e.target.value}))}
          placeholder="Last name *" className="px-3 py-2 border rounded-lg text-sm" style={{ borderColor: '#E0E0E0' }} data-testid="add-last-name" />
        <select value={addForm.grade} onChange={e => setAddForm(p => ({...p, grade: e.target.value}))}
          className="px-3 py-2 border rounded-lg text-sm" style={{ borderColor: '#E0E0E0' }} data-testid="add-grade">
          <option value="">Team</option>
          {US_GRADES.map(g => <option key={g} value={g}>{g}</option>)}
        </select>
        <input value={addForm.section} onChange={e => setAddForm(p => ({...p, section: e.target.value}))}
          placeholder="Section / Class" className="px-3 py-2 border rounded-lg text-sm" style={{ borderColor: '#E0E0E0' }} data-testid="add-section" />
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-3">
        <input value={addForm.teacher_name} onChange={e => setAddForm(p => ({...p, teacher_name: e.target.value}))}
          placeholder="Teacher name" className="px-3 py-2 border rounded-lg text-sm" style={{ borderColor: '#E0E0E0' }} data-testid="add-teacher" />
        <select value={addForm.gender} onChange={e => setAddForm(p => ({...p, gender: e.target.value}))}
          className="px-3 py-2 border rounded-lg text-sm" style={{ borderColor: '#E0E0E0' }} data-testid="add-gender">
          <option value="">Gender</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
          <option value="other">Other</option>
        </select>
        <input value={addForm.parent_email} onChange={e => setAddForm(p => ({...p, parent_email: e.target.value}))}
          placeholder="Parent email" className="px-3 py-2 border rounded-lg text-sm" style={{ borderColor: '#E0E0E0' }} data-testid="add-parent-email" />
        <input value={addForm.parent_name} onChange={e => setAddForm(p => ({...p, parent_name: e.target.value}))}
          placeholder="Parent name" className="px-3 py-2 border rounded-lg text-sm" style={{ borderColor: '#E0E0E0' }} data-testid="add-parent-name" />
      </div>
      <div className="flex gap-2">
        <button onClick={addStudent} disabled={saving || !addForm.first_name.trim() || !addForm.last_name.trim()}
          className="px-4 py-2 rounded-lg text-sm font-medium text-white disabled:opacity-50 flex items-center gap-1.5"
          style={{ backgroundColor: '#2EAA5C' }} data-testid="save-student-btn">
          {saving ? <Loader2 size={14} className="animate-spin" /> : <Check size={14} />} Save
        </button>
        <button onClick={() => setShowAddForm(false)} className="px-4 py-2 rounded-lg text-sm font-medium" style={{ backgroundColor: '#F0F0F0', color: '#666' }}>Cancel</button>
      </div>
    </div>
  )}

  {/* Filters */}
  <div className="flex gap-2 mb-4">
    <div className="relative flex-1">
      <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: '#AAA' }} />
      <input value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search members..."
        className="w-full pl-8 pr-3 py-2 border rounded-lg text-sm" style={{ borderColor: '#E0E0E0' }} data-testid="student-search" />
    </div>
    <select value={teamFilter} onChange={e => setTeamFilter(e.target.value)}
      className="px-3 py-2 border rounded-lg text-sm" style={{ borderColor: '#E0E0E0' }} data-testid="grade-filter">
      <option value="">All Teams</option>
      {US_GRADES.map(g => <option key={g} value={g}>{g}</option>)}
    </select>
    <select value={leadFilter} onChange={e => setLeadFilter(e.target.value)}
      className="px-3 py-2 border rounded-lg text-sm" style={{ borderColor: '#E0E0E0' }} data-testid="teacher-filter">
      <option value="">All Team Leads</option>
      {summary?.by_teacher?.map(t => <option key={t.teacher} value={t.teacher}>{t.teacher} ({t.count})</option>)}
    </select>
  </div>

  {/* Bulk Actions */}
  {selectedStudents.length > 0 && (
    <div className="flex items-center gap-3 mb-3 px-3 py-2.5 rounded-lg" style={{ backgroundColor: '#EFF6FF', border: '1px solid #BFDBFE' }} data-testid="bulk-actions-bar">
      <span className="text-xs font-semibold" style={{ color: '#2563EB' }}>{selectedStudents.length} selected</span>
      <button onClick={async () => {
        try {
          const res = await fetch(`${API_URL}/api/corporate/members/bulk-nudge`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
            body: JSON.stringify({ student_ids: selectedStudents }),
          });
          if (res.ok) { const d = await res.json(); alert(`Nudged ${d.nudged_count} students`); setSelectedStudents([]); }
        } catch {}
      }} className="px-3 py-1.5 rounded-lg text-[10px] font-semibold text-white" style={{ backgroundColor: '#2563EB' }} data-testid="bulk-nudge-btn">
        <Bell size={10} className="inline mr-1" /> Nudge Selected
      </button>
      <button onClick={() => setBulkAction('assign')} className="px-3 py-1.5 rounded-lg text-[10px] font-semibold" style={{ backgroundColor: '#F0F0F0', color: '#555' }} data-testid="bulk-assign-btn">
        <Users size={10} className="inline mr-1" /> Assign Class/Teacher
      </button>
      <button onClick={() => setSelectedStudents([])} className="text-[10px] ml-auto" style={{ color: '#999' }}>Clear</button>
    </div>
  )}

  {/* Bulk assign modal */}
  {bulkAction === 'assign' && (
    <div className="bg-white p-4 rounded-xl mb-3" style={{ border: '2px solid #2563EB33' }}>
      <h3 className="text-sm font-bold mb-3" style={{ color: '#1A1209' }}>Bulk Assign {selectedStudents.length} Students</h3>
      <div className="grid grid-cols-2 gap-2 mb-3">
        <input placeholder="Section / Class" id="bulk-section" className="px-3 py-2 border rounded-lg text-sm" style={{ borderColor: '#E0E0E0' }} />
        <input placeholder="Teacher Name" id="bulk-teacher" className="px-3 py-2 border rounded-lg text-sm" style={{ borderColor: '#E0E0E0' }} />
      </div>
      <div className="flex gap-2">
        <button onClick={async () => {
          const section = document.getElementById('bulk-section').value;
          const teacher = document.getElementById('bulk-teacher').value;
          if (!section && !teacher) return;
          try {
            const res = await fetch(`${API_URL}/api/corporate/members/bulk-assign`, {
              method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
              body: JSON.stringify({ student_ids: selectedStudents, section, teacher_name: teacher }),
            });
            if (res.ok) { const d = await res.json(); alert(`Updated ${d.updated_count} students`); setBulkAction(null); setSelectedStudents([]); fetchStudents(); }
          } catch {}
        }} className="px-4 py-2 rounded-lg text-sm font-medium text-white" style={{ backgroundColor: '#2EAA5C' }}>Apply</button>
        <button onClick={() => setBulkAction(null)} className="px-4 py-2 rounded-lg text-sm" style={{ backgroundColor: '#F0F0F0', color: '#666' }}>Cancel</button>
      </div>
    </div>
  )}

  {/* Student table */}
  <div className="bg-white rounded-xl overflow-hidden" style={{ border: '1px solid #E8E8E8' }} data-testid="student-table">
    <table className="w-full">
      <thead>
        <tr style={{ backgroundColor: '#F8F7F4', borderBottom: '1px solid #E8E8E8' }}>
          <th className="px-2 py-2.5 w-8">
            <input type="checkbox" checked={selectedStudents.length === members.length && members.length > 0}
              onChange={e => setSelectedStudents(e.target.checked ? members.map(s => s.student_id) : [])}
              className="w-3.5 h-3.5 rounded" data-testid="select-all-students" />
          </th>
          <th className="px-4 py-2.5 text-left text-[11px] font-semibold uppercase" style={{ color: '#999' }}>Name</th>
          <th className="px-4 py-2.5 text-left text-[11px] font-semibold uppercase" style={{ color: '#999' }}>Team</th>
          <th className="px-4 py-2.5 text-left text-[11px] font-semibold uppercase" style={{ color: '#999' }}>Section</th>
          <th className="px-4 py-2.5 text-left text-[11px] font-semibold uppercase" style={{ color: '#999' }}>Team Lead</th>
          <th className="px-4 py-2.5 text-left text-[11px] font-semibold uppercase" style={{ color: '#999' }}>Gender</th>
          <th className="px-4 py-2.5 text-left text-[11px] font-semibold uppercase" style={{ color: '#999' }}>Parent</th>
          <th className="px-4 py-2.5 text-right text-[11px] font-semibold uppercase" style={{ color: '#999' }}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {members.length === 0 ? (
          <tr><td colSpan={8} className="px-4 py-12 text-center text-sm" style={{ color: '#AAA' }}>No students found. Add students individually or upload a CSV.</td></tr>
        ) : members.map((s, i) => {
          const isEditing = editingStudent === s.student_id;
          const isSelected = selectedStudents.includes(s.student_id);
          return (
            <tr key={s.student_id} className="hover:bg-gray-50" style={{ borderBottom: '1px solid #F0F0F0', backgroundColor: isSelected ? '#EFF6FF' : i % 2 === 0 ? undefined : undefined }} data-testid={`student-row-${i}`}>
              <td className="px-2 py-2.5 w-8">
                <input type="checkbox" checked={isSelected}
                  onChange={e => setSelectedStudents(prev => e.target.checked ? [...prev, s.student_id] : prev.filter(id => id !== s.student_id))}
                  className="w-3.5 h-3.5 rounded" />
              </td>
              {isEditing ? (
                <>
                  <td className="px-4 py-2">
                    <div className="flex gap-1">
                      <input value={editForm.first_name} onChange={e => setEditForm(p => ({...p, first_name: e.target.value}))} className="px-1.5 py-1 border rounded text-xs w-20" style={{ borderColor: '#E0E0E0' }} />
                      <input value={editForm.last_name} onChange={e => setEditForm(p => ({...p, last_name: e.target.value}))} className="px-1.5 py-1 border rounded text-xs w-20" style={{ borderColor: '#E0E0E0' }} />
                    </div>
                  </td>
                  <td className="px-4 py-2">
                    <select value={editForm.grade} onChange={e => setEditForm(p => ({...p, grade: e.target.value}))} className="px-1.5 py-1 border rounded text-xs" style={{ borderColor: '#E0E0E0' }}>
                      <option value="">-</option>
                      {US_GRADES.map(g => <option key={g} value={g}>{g}</option>)}
                    </select>
                  </td>
                  <td className="px-4 py-2"><input value={editForm.section} onChange={e => setEditForm(p => ({...p, section: e.target.value}))} className="px-1.5 py-1 border rounded text-xs w-16" style={{ borderColor: '#E0E0E0' }} /></td>
                  <td className="px-4 py-2"><input value={editForm.teacher_name} onChange={e => setEditForm(p => ({...p, teacher_name: e.target.value}))} className="px-1.5 py-1 border rounded text-xs w-24" style={{ borderColor: '#E0E0E0' }} /></td>
                  <td className="px-4 py-2">
                    <select value={editForm.gender} onChange={e => setEditForm(p => ({...p, gender: e.target.value}))} className="px-1.5 py-1 border rounded text-xs" style={{ borderColor: '#E0E0E0' }}>
                      <option value="">-</option><option value="male">M</option><option value="female">F</option><option value="other">O</option>
                    </select>
                  </td>
                  <td className="px-4 py-2"><input value={editForm.parent_email} onChange={e => setEditForm(p => ({...p, parent_email: e.target.value}))} className="px-1.5 py-1 border rounded text-xs w-28" style={{ borderColor: '#E0E0E0' }} /></td>
                  <td className="px-4 py-2 text-right">
                    <div className="flex gap-1 justify-end">
                      <button onClick={() => saveEdit(s.student_id)} className="p-1.5 rounded" style={{ backgroundColor: '#2EAA5C15' }}><Check size={13} style={{ color: '#2EAA5C' }} /></button>
                      <button onClick={() => setEditingStudent(null)} className="p-1.5 rounded" style={{ backgroundColor: '#F0F0F0' }}><X size={13} style={{ color: '#999' }} /></button>
                    </div>
                  </td>
                </>
              ) : (
                <>
                  <td className="px-4 py-2.5 text-sm font-medium" style={{ color: '#1A1209' }}>{s.first_name} {s.last_name}</td>
                  <td className="px-4 py-2.5 text-xs">
                    <span className="px-2 py-0.5 rounded-full font-medium" style={{ backgroundColor: '#F5831F15', color: '#F5831F' }}>{s.grade || '-'}</span>
                  </td>
                  <td className="px-4 py-2.5 text-xs" style={{ color: '#666' }}>{s.section || '-'}</td>
                  <td className="px-4 py-2.5 text-xs" style={{ color: '#666' }}>{s.teacher_name || '-'}</td>
                  <td className="px-4 py-2.5 text-xs capitalize" style={{ color: '#666' }}>{s.gender || '-'}</td>
                  <td className="px-4 py-2.5 text-xs" style={{ color: '#666' }}>{s.parent_email || '-'}</td>
                  <td className="px-4 py-2.5 text-right">
                    <div className="flex gap-1 justify-end">
                      <button onClick={() => startEdit(s)} className="p-1.5 rounded hover:bg-gray-100" data-testid={`edit-student-${i}`}><Edit2 size={13} style={{ color: '#F5831F' }} /></button>
                      <button onClick={() => deleteStudent(s.student_id, `${s.first_name} ${s.last_name}`)} className="p-1.5 rounded hover:bg-gray-100" data-testid={`delete-student-${i}`}><Trash2 size={13} style={{ color: '#DC2626' }} /></button>
                    </div>
                  </td>
                </>
              )}
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
</div>
  );
};

export default StudentsTab;
